import { parse } from "@config/theme";
import { css } from "linaria";
import { rem } from "polished";
export const item = parse({}, "irqszir");
export const imageContainer = parse({
  position: "relative",
  width: "100%"
}, "itlmf8q");
export const image = parse({
  position: "absolute"
}, "i1twu4jr");
export const divider = parse({
  bg: "white",
  position: "relative"
}, "d1j2omft");

require("./ThreeColImages.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ThreeColImages.styles.ts");